/* ------------------------------------------------------------------
 * 参加フィードバックフォームの動的表示制御
 * has_participatedラジオボタンの選択に応じて設問セクションを切り替える
 * PC版・スマホ版共通で使用
--------------------------------------------------------------------- */
// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (
    !$(
      "body.after_volunteer_feedbacks.new, body.after_volunteer_feedbacks.create"
    ).length
  )
    return;
  const hasParticipatedTrue = document.getElementById("has_participated_true");
  const hasParticipatedFalse = document.getElementById(
    "has_participated_false"
  );
  const participatedSection = document.getElementById("jsParticipatedSection");
  const notParticipatedSection = document.getElementById(
    "jsNotParticipatedSection"
  );
  const formFooter = document.querySelector(".formFooter");

  // （また参加したい活動の種類）セクションの表示制御用
  const wantsToParticipateAgainTrue = document.getElementById(
    "wants_to_participate_again_true"
  );
  const wantsToParticipateAgainFalse = document.getElementById(
    "wants_to_participate_again_false"
  );
  const preferredActivitySection = document.getElementById(
    "jsPreferredActivitySection"
  );

  // セクションの表示状態を更新
  function updateSectionVisibility() {
    if (hasParticipatedTrue.checked) {
      participatedSection.style.display = "";
      notParticipatedSection.style.display = "none";
      formFooter.style.display = "";
      updatePreferredActivitySectionVisibility();
      return;
    }

    if (hasParticipatedFalse.checked) {
      participatedSection.style.display = "none";
      notParticipatedSection.style.display = "";
      formFooter.style.display = "";
      return;
    }

    // どちらも選択されていない場合は全て非表示
    participatedSection.style.display = "none";
    notParticipatedSection.style.display = "none";
    formFooter.style.display = "none";
  }

  // （また参加したい活動の種類）セクションの表示状態を更新
  function updatePreferredActivitySectionVisibility() {
    if (wantsToParticipateAgainTrue.checked) {
      preferredActivitySection.style.display = "";
    } else {
      preferredActivitySection.style.display = "none";
    }
  }

  // ラジオボタンの変更イベントを登録
  hasParticipatedTrue.addEventListener("change", updateSectionVisibility);
  hasParticipatedFalse.addEventListener("change", updateSectionVisibility);

  // （また参加したいか）セクションのラジオボタンの変更イベントを登録
  wantsToParticipateAgainTrue.addEventListener(
    "change",
    updatePreferredActivitySectionVisibility
  );
  wantsToParticipateAgainFalse.addEventListener(
    "change",
    updatePreferredActivitySectionVisibility
  );

  // 「その他」チェックボックスの自動チェック
  const otherReasonCheckbox = document.getElementById(
    "non_participation_reason_10"
  );
  const otherReasonText = document.getElementById("other_reason_text");

  function updateOtherReasonCheckbox() {
    if (otherReasonText.value.length > 0) {
      otherReasonCheckbox.checked = true;
    }
  }

  otherReasonText.addEventListener("input", updateOtherReasonCheckbox);

  // ページ読み込み時の初期状態を設定
  updateSectionVisibility();
});
